import { useContext } from 'react';

import { SnackbarContext, ContextProps } from 'providers/SnackbarProvider';

export function useSnackbar(): ContextProps {
  return useContext(SnackbarContext);
}
